import React from 'react';
import { Spin } from 'antd';

type Props = {
  children: JSX.Element;
  loading: boolean;
};

export const LoadingWrapper = ({ children, loading = false }: Props) => {
  if (loading) {
    return <Spin>{children}</Spin>;
  }

  return children;
};
